module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Mouse-a488249c8ceeaa48aa97de01a49dfa6d.svg";